import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_section, remove_entry, rename_section, set_current_section } from "../../actions/ExpenseBucket";
import stylelist from "stylelist";
import MinutesToTime from "./MinutesToTime";
import axios from "axios";
import SyncConstants from "../../constants/SyncConstants";
import ConfirmButton from "./ConfirmButton";

const ExpenseBucketSection = (props) => {
    const dispatch = useDispatch();
    const ExpenseBucket = useSelector((state) => state.ExpenseBucket);
    const UserSettings = useSelector((state) => state.User);

    const [editName, setEditName] = useState(false);
    const [expandView, setExpandView] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [currentModalTab, setCurrentModalTab] = useState("text");

    const [currentMinuteSum, setCurrentMinuteSum] = useState(0);
    const [textFormat, setTextFormat] = useState("");

    const MinutesToTimeString = (minutes) => {
        return Math.floor(minutes / 60).toString().padStart(2,"0") + ":" + (minutes % 60).toString().padStart(2,"0");
    }

    useEffect(() => {
        let newMinuteSum = 0;
        let newString = "";

        ExpenseBucket.sections[props.uuid].expenses.forEach(e => {
            newMinuteSum = newMinuteSum + parseInt(e.minutes);
            newString += "- " + e.comment + " (" + e.date + " - " + MinutesToTimeString(e.minutes)+ ") \n";
        });

        setTextFormat(ExpenseBucket.sections[props.uuid].name + " (Gesamt: " + MinutesToTimeString(newMinuteSum) + ")\n\n" + newString);
        setCurrentMinuteSum(newMinuteSum);
    }, [ExpenseBucket]);

    const getAuthObject = () => {
        return {
            username: UserSettings.userName,
            password: UserSettings.syncToken
        }
    }

    const markAsAccounted = () => {
        axios({
            method: "post",
            auth: getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "markAsAccounted",
            responseType: 'json',
            data: { entry_ids: ExpenseBucket.sections[props.uuid].expenses }
        }).then((response) => {
            props.forceTreeReload();
            ExpenseBucket.sections[props.uuid].expenses.forEach(entry => {
                dispatch(remove_entry(entry.id))
            });
            alert("Die Aufwände wurden serverseitig als 'Abgerechnet' markiert. Sie werden in Slotify aktualisiert, sobald die Maske aktualisiert wurde.");

        }).catch(response => { });
    }

    return <>
        <li class={stylelist(
            "list-group-item",
            "bg-light"
        )}>

            {showModal && <>
                <div className="overlay d-flex justify-content-center align-items-center">
                    <div class="modal d-block">
                        <div class="modal-dialog" style={{minWidth : "1024px"}}>
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{ExpenseBucket.sections[props.uuid].name} abrechnen</h5>
                                    <button type="button" class="btn-close"  onClick={() => {setShowModal(false)}} aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <p>
                                     <h6>
                                        <span onClick={() => {setCurrentModalTab("text")}} class="badge text-bg-secondary cursor-pointer">Formatierter Text (WeClapp)</span>
                                        &nbsp;
                </h6>
                                    </p>

                                 {currentModalTab == "text" && 
                                    <>
                                        <textarea class="form-control" value={textFormat} style={{minWidth : "924px", minHeight: "500px"}}/>
                              
                                    </>
                                 }
                                </div>
                                <div class="modal-footer">
                                <ConfirmButton className="small text-primary cursor-pointer" labelConfirm="Zum Server senden" label="Als 'abgerechnet' markieren" onConfirm={e => { markAsAccounted() }} />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}

            <div className="d-flex justify-content-between">
                <div>
                    {!editName &&
                        <>
                            <input
                                checked={ExpenseBucket.currentSection == props.uuid ? true : false}
                                onClick={() => { dispatch(set_current_section(props.uuid)) }}
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1" /> &nbsp;
                            <span onClick={() => { setExpandView(!expandView) }} className="cursor-pointer">{ExpenseBucket.sections[props.uuid].name}</span>
                        </>
                    }

                    {editName &&
                        <>
                            <input className="form-control" type="text" value={ExpenseBucket.sections[props.uuid].name} onChange={(e) => { dispatch(rename_section(props.uuid, e.target.value)) }} />
                        </>
                    }
                </div>

                {Boolean(ExpenseBucket.currentSection == props.uuid && !editName) &&
                    <span className="text-primary cursor-pointer" onClick={() => { setEditName(true) }}>
                        Umbenennen
                    </span>
                }


                {Boolean(ExpenseBucket.currentSection == props.uuid && editName) &&
                    <span className="text-primary cursor-pointer mt-2 ms-1" onClick={() => { setEditName(false) }}>
                        Schließen
                    </span>
                }
            </div>

            {Boolean(ExpenseBucket.currentSection == props.uuid && !editName) &&
                <>
                    <table className={
                        stylelist(
                            "table table-light mb-0",
                            [ExpenseBucket.sections[props.uuid].expenses.length, "mt-2"]
                        )}>
                        {ExpenseBucket.sections[props.uuid].expenses.map(e => {
                            return <>
                                <tbody>
                                    <tr>
                                        <td className="small text-muted align-middle">{e.comment}</td>
                                        <td className="small text-muted align-middle"><MinutesToTime minutes={e.minutes} /></td>
                                        <td className="small text-muted align-middle">{e.date}</td>
                                        <td className="small text-muted align-middle"><span onClick={f => { dispatch(remove_entry(e.id)) }} className="text-primary small cursor-pointer">x</span></td>
                                    </tr>
                                </tbody>
                            </>
                        })}
                    </table>

                    {Boolean(ExpenseBucket.sections[props.uuid].expenses.length) &&
                        <>
                            <br />
                            <span className="small text-primary cursor-pointer" onClick={() => {setShowModal(true)}}>Exportieren</span>
                        </>
                    }
                </>
            }

        </li>
    </>
}

export default ExpenseBucketSection;